module.exports = __webpack_public_path__ + "img/wz-7-1-3.7be354af.jpg";